import React, { useEffect } from "react";
import { Button } from "primereact/button";
import { useSelector } from "react-redux";
import {
  descargarCroquisPorSolicitud,
  setCroquis,
  setMessageError,
} from "../sliceRedux/Reserva.slice";
import RenderToast from "./RenderToast";
import { Image } from "primereact/image";

const DownloadCroquis = ({ toast, showLoader, hideLoader, codSolicitud, dispatch }) => {
  const croquis = useSelector((state) => state.reserva.croquis);
  const messageError = useSelector((state) => state.reserva.messageError);

  useEffect(() => {
    return () => {
      hideLoader();
      dispatch(setCroquis({ ...croquis, code: 0 }));
    };
  }, [croquis.code]);

  const handleDownload = () => {
    showLoader();
    dispatch(descargarCroquisPorSolicitud(codSolicitud));
  };

  useEffect(() => {
    if (messageError != "") {
      RenderToast(toast, "error", "Error", messageError);
    }
    return () => {
      hideLoader();
      dispatch(setMessageError(""));
    };
  }, [messageError]);

  return (
    <>
      {!croquis?.object && (
        <Button
          label="Ver coquis"
          icon="pi pi-map"
          iconPos="right"
          onClick={() => handleDownload()}
          rounded
          className="mr-1"
          severity="secondary"
        />
      )}
      {croquis?.object && (
        <div className="flex col-12 md:col-12">
          <label
            htmlFor="parroquia"
            className="mr-2"
            style={{ minWidth: "110px", textAlign: "left" }}
          >
            Croquis:
          </label>
          <div className="flex justify-content-center">
            <Image
              src={"data:image/jpeg;base64, " + croquis?.object?.bytesArchivo}
              zoomSrc={"data:image/jpeg;base64, " + croquis?.object?.bytesArchivo}
              alt="Croquis"
              width="200"
              height="150"
              preview
            />
          </div>
        </div>
      )}
    </>
  );
};

export default DownloadCroquis;
